module.exports = __webpack_public_path__ + "media/images/favicon-16x16-fff0300da398be00f3fa80db2606a692.png";